import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import colors from '../../configuration/colors'
import { hideModal } from '../../actions/modal'
import Modal from '../mini/Modal'
import Button from '../mini/Buttons/Button'
import styled from 'styled-components'
import P2 from '../typography/paragraphs/P2'
import Caption4 from '../typography/captions/Caption4'
import ReactTooltip from 'react-tooltip'
import { cleanHexCode } from '../mycourses/util'
import GradeElement from '../mini/GradeElement'

const ModalContainer = styled.div`
  width: 519px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);
  background: ${colors.white};
  margin: 180px auto;
  padding-top: 40px;
`

const Header = styled.div`
  padding: 0 23px;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin-bottom: 23px;
`

const CourseName = styled.h3`
  color: ${props => props.color};
  font-family: Montserrat, sans-serif;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  margin-left: -15px;
`

const MainContainer = styled.div`
  display: flex;
  padding: 10px 23px;
  border-bottom: 1px solid ${colors.ash};
  align-items: center;
  align-content: center;
  background-color: ${colors.white};
  border: none;
  margin: 0 auto;
  padding: 0;
  text-align: center;
`

const DescriptionText = styled.h3`
  width: 419px;
  color: #000000;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  margin: 0 auto;
  padding-bottom: 43px;
`

const ButtonBlock = styled.div`
  border-top: 1px solid #eeeeee;
`

const InformativeModal = ({
  activityCourse,
  description,
  gradeLevel,
  supportiveText
}) => {
  const dispatch = useDispatch()

  const closeTheModal = () => {
    setTimeout(() => {
      dispatch(hideModal())
    }, 300)
  }

  return (
    <Modal
      width={1400}
      percentHeight={100}
      background={'rgba(36,54,70,0.48)'}
      lockBodyScroll={false}
      opacity={'.9'}
      allowInnerScroll
      allowCloseOnExternalClick={false}
    >
      <ModalContainer>
        {!!gradeLevel && !!activityCourse && (
          <Header>
            <GradeElement
              name={gradeLevel.name}
              abbreviation={gradeLevel.abbreviation}
              style={{ marginRight: '28px' }}
            />
            <CourseName color={cleanHexCode(activityCourse.color)}>
              {activityCourse.name}
            </CourseName>
          </Header>
        )}
        <MainContainer>
          <DescriptionText>{description}</DescriptionText>
        </MainContainer>
        {supportiveText && (
          <P2
            style={{
              textAlign: 'center',
              marginTop: '-30px',
              paddingBottom: '20px'
            }}
          >
            {supportiveText}
          </P2>
        )}
        <ButtonBlock>
          <div
            style={{
              marginLeft: '40%',
              paddingTop: '23px',
              paddingBottom: '30px'
            }}
          >
            <Button
              buttonColor={colors.white}
              width="95px"
              borderColor={colors.aluminum}
              title="OK"
              handleClick={() => closeTheModal()}
              hoverBackground={colors.charcoal4}
              hoverColor={colors.white}
            />
          </div>
        </ButtonBlock>
      </ModalContainer>
    </Modal>
  )
}

InformativeModal.propTypes = {
  activityCourse: PropTypes.object,
  gradeLevel: PropTypes.object,
  description: PropTypes.string.isRequired,
  supportiveText: PropTypes.string
}

export default InformativeModal



// WEBPACK FOOTER //
// ./src/components/modal/InformativeModal.js